import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ActivatedRoute, Router } from '@angular/router';
import { AcceptInvitationComponent } from '../accept-invitation/accept-invitation.component';
import { ApiService } from '../../../shared/services/api.service';
import {
  AcceptOrDeclineCollaborationMutation,
  AcceptOrDeclineCollaborationMutationVariables,
  Action,
  CollaborationStatus,
} from '../../../../API';
import { AcceptOrDeclineCollaboration } from '../../../../graphql/mutations';
import { CollaborationDataService } from '../../services/collaboration-data.service';
import { UserManagementService } from '../../../shared/services/user-management.service';

@Component({
  selector: 'app-view-collaboration-invite',
  templateUrl: './view-collaboration-invite.component.html',
  styleUrl: './view-collaboration-invite.component.scss',
})
export class ViewCollaborationInviteComponent implements OnDestroy, OnInit {
  @ViewChild(AcceptInvitationComponent) acceptInvitationComponent?: AcceptInvitationComponent;

  collaborationId!: string;
  currentStep: number = 0;
  orgType: string = '';
  isAccepted?: boolean = false;
  isLoading: boolean = false;

  constructor(
    private nzMessageService: NzMessageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private collaborationDataService: CollaborationDataService,
    private userManagementService: UserManagementService,
  ) {}

  ngOnDestroy(): void {
    this.collaborationId = '';
  }

  ngOnInit(): void {
    this.collaborationId = this.activatedRoute.snapshot.paramMap.get('collaborationId') ?? '';

    if (!this.collaborationId) {
      this.nzMessageService.error('Invalid collaboration! Failed to fetch collaboration details');
      this.redirectToList();
      return;
    }

    this.acceptInvitationComponent?.agreeFormControl.valueChanges.subscribe((newValue) => {
      this.isAccepted = newValue;
    });
  }

  redirectToList() {
    this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
  }

  next() {
    this.currentStep = 1;
  }

  prevStep() {
    this.currentStep = 0;
  }

  isFormValid(state: boolean) {
    this.isAccepted = state;
  }

  setOwnerOrgType(ownerOrgType: string) {
    this.orgType = ownerOrgType;
  }

  acceptInvitation() {
    this.isLoading = true;
    // TODO: Remove this, this is just to trigger pipeline
    const selectedDataset = this.getSelectedDataset();

    this.apiService
      .query<AcceptOrDeclineCollaborationMutation, AcceptOrDeclineCollaborationMutationVariables>(
        AcceptOrDeclineCollaboration,
        {
          collaborationRequest: {
            action: Action.UPDATE,
            collaborationId: this.collaborationId!,
            orgType: this.orgType,
            status: CollaborationStatus.ACTIVE,
            partnerDatasets: selectedDataset,
            lastModifiedBy: this.userManagementService.getEmail(),
          },
        },
      )
      .then((response) => {
        const result = response?.data?.AcceptOrDeclineCollaboration;
        console.log('result', result);
        this.nzMessageService.success('Invitation accepted successfully');
        this.redirectToList();
      })
      .catch((error) => {
        console.log('error', error);
        this.nzMessageService.error('Failed to accept the invite');
      })
      .finally(() => (this.isLoading = false));
  }

  getSelectedDataset() {
    const collaborationData = this.collaborationDataService.getCompleteCollaborationData();
    const updatedDataset =
      collaborationData.ownerDatasets?.map((dataset: any) => ({
        dataConnectionId: dataset.dataConnectionId,
        dataConnectionName: dataset.dataConnectionName,
        schemaName: dataset.schemaName,
        tableName: dataset.tableName,
      })) || [];

    return updatedDataset;
  }
}
